/* eslint-disable import/no-anonymous-default-export */
const statusStockState = {
    isAdd: false,
    isAddDetail: false,
    isUpdate: false,
    isGet: false,
    isDelete: false,
    isLoading: false,
    isError: false,
    alertMsg: '',
    dataStatusStock: [],
    dataName: [],
    alertM: '',
    alertUpload: [],
    page: {},
    isExport: false,
    detStatusStock: {},
    link: '',
    dataAll: [],
    isAll: false,
    isUpload: false,
    dataDropdownStatus: [],
    dataDropdown: []
};

export default (state=statusStockState, action) => {
        switch(action.type){
            case 'GET_ALLSTATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'GET_ALLSTATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isAll: true,
                    dataAll: action.payload.data.result.rows,
                    alertMsg: 'get glikk Succesfully',
                    page: action.payload.data.pageInfo
                };
            }
            case 'GET_ALLSTATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: "Failed get data glikk"
                };
            }
            case 'GET_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'GET_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isGet: true,
                    dataStatusStock: action.payload.data.result,
                    alertMsg: 'get glikk Succesfully'
                };
            }
            case 'GET_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: "Unable connect to server"
                };
            }
            case 'DETAIL_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'DETAIL_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isGet: true,
                    detStatusStock: action.payload.data.result,
                    alertMsg: 'get detail glikk Succesfully',
                };
            }
            case 'DETAIL_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: "Unable connect to server"
                };
            }
            case 'NEXT_DATA_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'NEXT_DATA_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isAll: true,
                    dataAll: action.payload.data.result.rows,
                    alertMsg: 'next data Succesfully',
                    page: action.payload.data.pageInfo
                };
            }
            case 'NEXT_DATA_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isAll: false,
                    isError: true,
                    alertMsg: "Unable connect to server"
                };
            }
            case 'UPDATE_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting'
                };
            }
            case 'UPDATE_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isUpdate: true,
                    alertMsg: 'update user Succesfully'
                };
            }
            case 'UPDATE_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: action.payload.response.data.message,
                    alertM: action.payload.response.data.error
                };
            }
            case 'ADD_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'ADD_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isAdd: true,
                    isError: false,
                    alertMsg: 'add user Succesfully'
                };
            }
            case 'ADD_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: action.payload.response.data.message,
                    alertM: action.payload.response.data.error
                };
            }
            case 'UPLOAD_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting....'
                };
            }
            case 'UPLOAD_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isUpload: true,
                    alertMsg: 'upload master Succesfully'
                };
            }
            case 'UPLOAD_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: action.payload.response.data.message,
                    alertUpload: action.payload.response.data.result
                };
            }
            case 'EXPORT_MASTER_STATUS_STOCK_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'EXPORT_MASTER_STATUS_STOCK_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    isExport: true,
                    link: action.payload.data.link,
                    alertMsg: 'success export data'
                };
            }
            case 'EXPORT_MASTER_STATUS_STOCK_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                    alertMsg: 'Failed export data'
                };
            }

            // DROPDOWN
            case 'ADD_DROPDOWN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'ADD_DROPDOWN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    addDropdown: true,
                    alertMsg: 'add dropdown Succesfully'
                };
            }
            case 'ADD_DROPDOWN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    addDropdown: false,
                };
            }
            case 'UPDATE_DROPDOWN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'UPDATE_DROPDOWN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    updateDropdown: true,
                    alertMsg: 'update dropdown Succesfully'
                };
            }
            case 'UPDATE_DROPDOWN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    updateDropdown: false,
                };
            }
            case 'DELETE_DROPDOWN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'DELETE_DROPDOWN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    deleteDropdown: true,
                    alertMsg: 'add dropdown Succesfully'
                };
            }
            case 'DELETE_DROPDOWN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    deleteDropdown: false,
                };
            }
            case 'GET_DROPDOWN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'GET_DROPDOWN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    getDropdown: true,
                    dataDropdown: action.payload.data.result,
                    alertMsg: 'add dropdown Succesfully'
                };
            }
            case 'GET_DROPDOWN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    getDropdown: false,
                };
            }
            case 'GET_DROPDOWN_BY_STATUSID_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Waiting ...'
                };
            }
            case 'GET_DROPDOWN_BY_STATUSID_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    dataDropdownStatus: action.payload.data.result,
                    alertMsg: 'add dropdown Succesfully'
                };
            }
            case 'GET_DROPDOWN_BY_STATUSID_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                };
            }
            case 'RESET_STATUS_STOCK': {
                return {
                    ...state,
                    isError: false,
                    isUpdate: false,
                    isAdd: false,
                    isDelete: false,
                    isGet: false,
                    isExport: false,
                    isLoading: false,
                    isUpload: false
                }
            }
            default: {
                return state;
            }
        }
    }